if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.headers['Content-Type'] = 'application/json';

        const formData = new FormData(this.form);
        const items = [];

        // Generate unique bundle identifier
        const bundleId = Date.now().toString() + Math.random().toString(36).substr(2, 9);

        // Collect existing properties from the form for the main product
        const mainProperties = {};
        for (let [key, value] of formData.entries()) {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (propertyMatch && value) {
            mainProperties[propertyMatch[1]] = value;
          }
        }

        this.applyCurrentVehicleProperty(mainProperties);

        // Add bundle properties to main product
        mainProperties['_bundle_id'] = bundleId;
        mainProperties['_bundle_type'] = 'main';

        const parsedQuantity = parseInt(formData.get('quantity'), 10);
        const mainQuantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;

        // Add the main product
        items.push({
          'id': parseInt(formData.get('id')),
          'quantity': mainQuantity,
          'properties': mainProperties
        });

        // Add each add-on with bundle properties (quantity is always 1)
        for (let [key, value] of formData.entries()) {
          const addonMatch = key.match(/^addon_id_(\d+)$/);
          if (addonMatch && value) {
            items.push({
              'id': parseInt(value),
              'quantity': 1,
              'properties': {
                '_bundle_id': bundleId,
                '_bundle_type': 'addon'
              }
            });
          }
        }

        const requestBody = {
          'items': items,
          'sections': this.minicart.getSectionsToRender().map((section) => section.section),
          'sections_url': window.location.pathname
        };

        config.body = JSON.stringify(requestBody);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.minicart.updateSectionContents();
              return;
            }

            this.minicart.renderContents(response);

            if (window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              if (this.quickViewDrawer) {
                this.quickViewDrawer.close();
                // Immediately re-add the 'drawer-open' class to avoid
                // the drawer backdrop from flashing.
                document.body.classList.add("drawer-open");
                setTimeout(() => this.minicart.open(), 200);
              } else {
                this.minicart.open(submitButton);
              }
            }

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".button-overlay-spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      applyCurrentVehicleProperty(properties) {
        if (Object.prototype.hasOwnProperty.call(properties, "Fitment")) {
          return;
        }

        const currentVehicle = this.currentVehicleForCartProperty();
        if (!currentVehicle?.id || !currentVehicle.displayName) {
          return;
        }

        if (!this.productMatchesCurrentVehicle(currentVehicle.id)) {
          return;
        }

        properties.Fitment = currentVehicle.displayName;
      }

      currentVehicleForCartProperty() {
        const controllerData = window.vehicleFitmentController?.getHistory?.();
        if (controllerData?.current) {
          return controllerData.current;
        }

        const storageData = window.ThemeStorage?.getJson?.("vehicle_fitment_history", {});
        return storageData?.current || null;
      }

      productMatchesCurrentVehicle(vehicleId) {
        const productFitmentIds = this.productFitmentIds();
        return productFitmentIds.has(String(vehicleId));
      }

      productFitmentIds() {
        const ids = new Set();
        const fitmentIdString = [
          this.form.dataset.productFitmentIds,
          this.dataset.productFitmentIds,
        ]
          .filter(Boolean)
          .join("|");

        fitmentIdString
          .split("|")
          .map((id) => id.trim())
          .filter(Boolean)
          .forEach((id) => ids.add(id));

        this.closest(".card-product")
          ?.querySelectorAll(".product-card-fitment[data-fitment-id]")
          .forEach((element) => {
            if (element.dataset.fitmentId) {
              ids.add(element.dataset.fitmentId);
            }
          });

        return ids;
      }
    },
  );
}
